import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CheckinIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M23 16V20C23 21.6543 21.6543 23 20 23H16V21H20C20.5513 21 21 20.5518 21 20V16H23Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M23 8V4C23 2.3457 21.6543 1 20 1H16V3H20C20.5513 3 21 3.44824 21 4V8H23Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M8 3V1H4C2.3457 1 1 2.3457 1 4V8H3V4C3 3.44824 3.44873 3 4 3H8Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M8 21H4C3.44873 21 3 20.5518 3 20V16H1V20C1 21.6543 2.3457 23 4 23H8V21Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13 13H15V15H13V13Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M17 15H15V17H13V19H15V17H17V19H19V17H17V15Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M17 15V13H19V15H17Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5C5.89543 5 5 5.89543 5 7V11H11V5H7ZM9 7H7V9H9V7Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5C18.1046 5 19 5.89543 19 7V11H13V5H17ZM15 7H17V9H15V7Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17C5 18.1046 5.89543 19 7 19H11V13H5V17ZM7 17H9V15H7V17Z",
    fill: "currentColor"
  }));
}